import { render, staticRenderFns } from "./PlasticulturalTab.vue?vue&type=template&id=726decc3&scoped=true&"
import script from "./PlasticulturalTab.vue?vue&type=script&lang=js&"
export * from "./PlasticulturalTab.vue?vue&type=script&lang=js&"
import style1 from "./PlasticulturalTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726decc3",
  null
  
)

export default component.exports